// src/components/CustomGantt.js
import React, { useState } from 'react';
import '../components/CustomGantt.css';

const CustomGantt = ({ bakimlar = [] }) => {
  const [haftaOffset, setHaftaOffset] = useState(0);
  const [arama, setArama] = useState('');

  const haftalikTarihleriGetir = () => {
    const bugun = new Date();
    const haftaninIlkGunu = new Date(bugun);
    haftaninIlkGunu.setDate(bugun.getDate() - bugun.getDay() + haftaOffset * 7);

    return Array.from({ length: 7 }, (_, i) => {
      const gun = new Date(haftaninIlkGunu);
      gun.setDate(gun.getDate() + i);
      return {
        tarih: gun.toISOString().split('T')[0],
        etiket: gun.toLocaleDateString('tr-TR', {
          weekday: 'short',
          day: 'numeric',
          month: 'short'
        })
      };
    });
  };

  const gunlukTarihEtiketleri = haftalikTarihleriGetir();
  const firmalar = [...new Set(bakimlar.map(b => `${b.firma} | ${b.kompresorModel}`))].map((etiket) => {
    const [firma, model] = etiket.split(' | ');
    const bugun = new Date();

    const planli = bakimlar.find(b => b.firma === firma && b.kompresorModel === model && b.durum === 'Planlı');
    let kalanGun = null;

    if (planli) {
      const planTarih = new Date(planli.tarih);
      kalanGun = Math.ceil((planTarih - bugun) / (1000 * 60 * 60 * 24));
    } else {
      const bakimVerisi = bakimlar.find(b => b.firma === firma && b.kompresorModel === model);
      const toplamSaat = Number(bakimVerisi?.toplamSaat) || 0;
      const gunlukSaat = Number(bakimVerisi?.gunlukCalismaSaati) || 1;
      const dongu = Number(bakimVerisi?.bakimDongusuA) || 0;

      if (gunlukSaat > 0 && dongu > 0) {
        const sonrakiSaat = Math.ceil((toplamSaat + 1) / dongu) * dongu;
        const kalanSaat = sonrakiSaat - toplamSaat;
        kalanGun = Math.ceil(kalanSaat / gunlukSaat);
      }
    }

    return { etiket, kalanGun };
  });

  const filtreliFirmalar = firmalar
    .filter(e => e.etiket.toLowerCase().includes(arama.toLowerCase()))
    .sort((a, b) => a.kalanGun - b.kalanGun);

  return (
    <div className="gantt-container">
      <div className="gantt-controls mb-3 flex justify-between items-center gap-4">
        <button className="gantt-nav" onClick={() => setHaftaOffset(haftaOffset - 1)}>⏮️ Önceki Hafta</button>
        <h3 className="gantt-week-title">📅 {gunlukTarihEtiketleri[0].etiket} – {gunlukTarihEtiketleri[6].etiket}</h3>
        <button className="gantt-nav" onClick={() => setHaftaOffset(haftaOffset + 1)}>Sonraki Hafta ⏭️</button>
      </div>

      <div className="mb-3">
        <input
          type="text"
          className="gantt-search"
          placeholder="🔍 Firma veya model ara..."
          value={arama}
          onChange={e => setArama(e.target.value)}
        />
      </div>

      <div className="gantt-header">
        <div className="gantt-row gantt-header-row">
          <div className="gantt-cell gantt-label">Firma / Model</div>
          <div className="gantt-cell gantt-kalan">Kalan Gün</div>
          {gunlukTarihEtiketleri.map((g, i) => (
            <div key={i} className="gantt-cell gantt-date">{g.etiket}</div>
          ))}
        </div>
      </div>

      <div className="gantt-body">
        {filtreliFirmalar.map(({ etiket, kalanGun }, sIndex) => (
          <div key={sIndex} className="gantt-row">
            <div className="gantt-cell gantt-label">{etiket}</div>
            <div className="gantt-cell gantt-kalan">
              {isNaN(kalanGun) ? '—' : kalanGun > 0 ? `⏳ ${kalanGun} gün` : kalanGun === 0 ? '⏰ Bugün' : `⚠️ ${-kalanGun} gün`}
            </div>
            {gunlukTarihEtiketleri.map((gun, gIndex) => {
              const eslesen = bakimlar.find(b =>
                `${b.firma} | ${b.kompresorModel}` === etiket && b.tarih === gun.tarih
              );

              let className = 'gantt-cell gantt-slot';
              let cellIcon = '';
              const tooltip = eslesen
                ? `📍 Durum: ${eslesen.durum}\n🏢 Firma: ${eslesen.firma}\n🔧 Model: ${eslesen.kompresorModel}\n📝 Açıklama: ${eslesen.aciklama || 'Yok'}`
                : '';

              if (eslesen) {
                const isGecmis = new Date(eslesen.tarih) < new Date() && eslesen.durum === 'Planlı';

                if (eslesen.durum === 'Tamamlandı') {
                  className += ' gantt-ok';
                  cellIcon = '✔️';
                } else if (isGecmis) {
                  className += ' gantt-missed';
                  cellIcon = '⚠️';
                } else {
                  className += ' gantt-plan';
                  cellIcon = '📅';
                }
              }

              return (
                <div
                  key={gIndex}
                  className={className}
                  title={tooltip}
                >
                  {cellIcon}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomGantt;
